var map = {
	"./Browser.js": 2601,
	"./ComposeWindowApp.js": 2142,
	"./PuttyTerminal.js": 4119,
	"./agentApp.js": 7197,
	"./avatar2App.js": 6953,
	"./avatarApp.js": 7969,
	"./base.js": 220,
	"./calApp.js": 1014,
	"./calcApp.js": 6788,
	"./calculatriceApp.js": 4641,
	"./chatApp.js": 4788,
	"./chattabApp.js": 8833,
	"./directoryApp.js": 119,
	"./emailApp.js": 8236,
	"./essaiApp.js": 5691,
	"./explorerApp.js": 2763,
	"./fureteurApp.js": 3158,
	"./iaApp.js": 4128,
	"./notepadApp.js": 1184,
	"./ollamaUtils.js": 402,
	"./paintApp.js": 1374,
	"./pdfApp.js": 3924,
	"./pictureApp.js": 3928,
	"./powerpointApp.js": 5786,
	"./puttyApp.js": 992,
	"./teamsApp.js": 5184,
	"./tryApp.js": 6729,
	"./user2App.js": 1195,
	"./vectorApp.js": 5660,
	"./videApp.js": 4852,
	"./viewerApp.js": 1144,
	"./word2App.js": 2284,
	"./wordApp.js": 9174,
	"./writerApp.js": 5411
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6910;